/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Job_Form_Enum_Structured_Independent_Work25Inputs */

const en_job_form_enum_structured_independent_work25 = /** @type {(inputs: Job_Form_Enum_Structured_Independent_Work25Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Structured and Independent Work`)
};

const de_job_form_enum_structured_independent_work25 = /** @type {(inputs: Job_Form_Enum_Structured_Independent_Work25Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strukturiertes und selbständiges Arbeiten`)
};

/**
* | output |
* | --- |
* | "Structured and Independent Work" |
*
* @param {Job_Form_Enum_Structured_Independent_Work25Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const job_form_enum_structured_independent_work25 = /** @type {((inputs?: Job_Form_Enum_Structured_Independent_Work25Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Job_Form_Enum_Structured_Independent_Work25Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_job_form_enum_structured_independent_work25(inputs)
	return en_job_form_enum_structured_independent_work25(inputs)
});
export { job_form_enum_structured_independent_work25 as "job_form_enum_STRUCTURED_INDEPENDENT_WORK" }